interface Role {
    value: string;
}

interface Roles {
    ADMINISTRATOR: Role;
    FINANCIAL_ADMINISTRATOR: Role;
    MANAGER: Role;
    LABORATORY_MANAGER: Role;
    LABORATORY_MICROBIOLOGIST: Role;
    LABORATORY_CHEMIST: Role;
    SALES_REPRESENTATIVE: Role;
    SALES_MANAGER: Role;
    LABORATORY_TECHNICIAN: Role;
    SERVICE_TECHNICIAN: Role;
    ROLE_OPERATOR: Role;
}

export const roles: Roles = Object.freeze({
    ADMINISTRATOR: {
        value: 'administrator',
    },
    FINANCIAL_ADMINISTRATOR: {
        value: 'financialAdministrator',
    },
    MANAGER: {
        value: 'manager',
    },
    LABORATORY_MANAGER: {
        value: 'laboratoryManager',
    },
    LABORATORY_MICROBIOLOGIST: {
        value: 'laboratoryMicrobiologist',
    },
    LABORATORY_CHEMIST: {
        value: 'laboratoryChemist',
    },
    SALES_REPRESENTATIVE: {
        value: 'salesRepresentative',
    },
    SALES_MANAGER: {
        value: 'salesManager',
    },
    LABORATORY_TECHNICIAN: {
        value: 'laboratoryTechnician',
    },
    SERVICE_TECHNICIAN: {
        value: 'serviceTechnician',
    },
    ROLE_OPERATOR: {
        value: 'operator',
    },
});

export default roles;
